import {throttle} from "./throttle";

export function trailerSection() {
  let
    breakpoint = 1024,
    win = $(window),
    trailerSection = $(".trailer-section"),
    getTickerTemplate = function (tickerItem) {
      let
        items = '',
        i = 0;

      for (; i < 3; i++) {
        items += tickerItem;
      }

      return `<div class="breaking-news-ticker"><div class="bn-news"><ul>${items}</ul></div></div>`;
    },

    initTicker = function () {
      let winWidth = parseInt(win[0].innerWidth);

      trailerSection.each(function () {
        let
          curSection = $(this),
          ticker;

        if (winWidth < breakpoint) {
          ticker = curSection.find('.breaking-news-ticker')

          if (ticker.length) {
            ticker.remove();
            curSection.data('isHasTicker', false);
          }
        } else if (!curSection.data('isHasTicker')) {
          let tickerItem = `<li><span>${curSection.find('h2, .h2').html()}</span></li>`;

          curSection.data('isHasTicker', true);
          curSection.find('.trailer-section-head>div').append(getTickerTemplate(tickerItem));

          curSection.find('.breaking-news-ticker').breakingNews({
            borderWidth: 0,
            radius: 0,
            scrollSpeed: 4,
            stopOnHover: !0
          });
        }
      });
    };

  // $(".trailer-section").on({
  //   'click': function (e) {
  //     e.preventDefault();
  //
  //     let
  //       section = $(e.delegateTarget),
  //       wrapVideos = section.find('.trailer-videos-inner'),
  //       url = $(this).data('video-scr'),
  //       src = url + (url.indexOf("?") > -1 ? "&" : "?") + 'autoplay=1&enablejsapi=1',
  //       popup = '<div class="trailer-video-popup">' +
  //         '<div>' +
  //         '<span class="close"><s></s></span>' +
  //         '<iframe src="' + src + '" frameborder="0" frameborder="0" autoplay allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
  //         '</div>' +
  //         '</div>';
  //
  //     wrapVideos.append(popup);
  //
  //     setTimeout(function () {
  //       section.addClass('show');
  //     }, 400);
  //   },
  //
  //   'mouseenter': function (e) {
  //     $(e.delegateTarget).addClass('active');
  //   },
  //
  //   'mouseleave': function (e) {
  //     $(e.delegateTarget).removeClass('active');
  //   }
  // }, '.button').on('click', '.close', function (e) {
  //   e.preventDefault();
  //
  //   let section = $(e.delegateTarget).removeClass('show');
  //
  //   setTimeout(function () {
  //     section.find('.trailer-video-popup').remove();
  //   }, 600);
  //
  // });

  win.on("load", function () {
    initTicker();

  }).on("resize", throttle(function () {
    initTicker();

  }, 405)).on("orientationchange", throttle(function () {
    initTicker();

  }, 405));
}


// WEBPACK FOOTER //
// ./assets/js/modules/trailerSection.js